<template>
  <form>
    <div id="div-dietary-diagnostic-form" class="vs-con-loading__container">
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
          v-for="(category) in data.categories"
          v-bind:key="category.id"
          v-bind:title="category.name"
        >
          <div class="vx-card">
            <div class="vx-card__header">
              <!-- card title -->
              <div class="vx-card__title">
                <h4 class="text-primary">{{ category.name }}</h4>
                <h6 style="color: rgb(184, 194, 204);">{{ category.description }}</h6>
              </div>

              <!-- card actions -->
              <div class="vx-card__actions">
                <slot name="actions">
                  <div class="vx-card__action-buttons">
                    <vs-button
                      @click="openDietaryDiagnosticCreateForm(category.id)"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-plus"
                      title="Adicionar"
                    ></vs-button>
                    &nbsp;
                    <vs-button
                      @click="openDietaryDiagnosticSelect(category.id)"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-search"
                      title="Procurar outras opções"
                    ></vs-button>
                  </div>
                </slot>
              </div>
            </div>

            <!-- card body -->
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body">
                <div
                  v-for="(diagnostic, index) in data.dietaryDiagnostics"
                  v-bind:key="diagnostic.id"
                  v-bind:title="diagnostic.name"
                  v-on:remove="data.dietaryDiagnostics.splice(index, 1)"
                >
                  <div
                    @change="changeDiagnostic(diagnostic, $event)"
                    v-if="diagnostic.idDietaryDiagnosticCategory == category.id && (diagnostic.alwaysShow == true || data.dietaryDiagnosticsSelected.filter(e => e.idDietaryDiagnostic === diagnostic.id).length > 0)"
                  >
                    <vs-checkbox
                      :checked="data.dietaryDiagnosticsSelected.filter(e => e.idDietaryDiagnostic === diagnostic.id).length > 0"
                      class="inline-flex"
                      v-model="data.dietaryDiagnosticsSelected"
                      :vs-value="{ id: 0, idAppointment: diagnostic.idAppointment, idDietaryDiagnostic: diagnostic.id }"
                    >{{ diagnostic.name }}</vs-checkbox>
                  </div>

                  <div v-if="diagnostic.hasValueInput == 1 && diagnostic.idDietaryDiagnosticCategory == category.id">
                    <vs-col
                      v-if="data.dietaryDiagnosticsSelected.filter(e => e.idDietaryDiagnostic === diagnostic.id).length > 0"
                      vs-type="flex"
                      vs-align="center"
                      vs-lg="12"
                      vs-sm="12"
                      vs-xs="12"
                    >
                      <vs-input
                        @change="changeDiagnostic(diagnostic)"
                        v-model="data.dietaryDiagnosticsSelected.filter(e => e.idDietaryDiagnostic === diagnostic.id)[0].value"
                        :name="diagnostic.idDietaryDiagnosticCategory"
                        label-placeholder="Valor"
                        class="mt-5 w-full"
                      />
                    </vs-col>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>

      <br />

      <div>
        <vs-popup fullscreen title="Diagnostico Alimentar" :active.sync="popupActive">
          <DietaryDiagnosticCreateForm
            v-bind:idDietaryDiagnosticCategory="this.idDietaryDiagnosticCategory"
          />
        </vs-popup>
      </div>

      <div>
        <vs-popup fullscreen title="Diagnostico Alimentar - Selecionar" :active.sync="selectPopUpActive">
          <DietaryDiagnosticSelect
            v-bind:idDietaryDiagnosticCategory="this.idDietaryDiagnosticCategory"
            v-bind:dietaryDiagnostics="this.data.dietaryDiagnostics"
            @DietaryDiagnosticSelect_submit="dietaryDiagnosticsSelected($event)"
          />
        </vs-popup>
      </div>
    </div>
  </form>
</template>

<script>
// Form
import DietaryDiagnosticCreateForm from "./DietaryDiagnosticCreateForm";
import DietaryDiagnosticSelect from "./DietaryDiagnosticSelect";

// Service
import DietaryDiagnosticService from "../../../../services/DietaryDiagnosticService";
import AppointmentDietaryDiagnosticService from "../../../../services/AppointmentDietaryDiagnosticService";

export default {
  components: {
    DietaryDiagnosticCreateForm,
    DietaryDiagnosticSelect
  },
  props: {
    idAppointment: {
      // type: Number,
      required: true
    }
  },
  data() {
    return {
      popupActive: false,
      selectPopUpActive: false,
      idDietaryDiagnosticCategory: 0,
      data: {
        id: 0,
        idAppointment: 0,
        dietaryDiagnostics: [],
        dietaryDiagnosticsSelected: [],
        categories: []
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      defaultDivId: "div-dietary-diagnostic-form"
    };
  },
  mounted: function() {
    this.data.idAppointment = this.$props.idAppointment;
    this.get();
  },
  methods: {
    async dietaryDiagnosticsSelected(dietaryDiagnostics) {
      dietaryDiagnostics.forEach(dietaryDiagnostic => {
        this.upsert(dietaryDiagnostic);
      });
    },
    async changeDiagnostic(diagnostic, event) {
      if (event == null) {
        diagnostic.value = this.data.dietaryDiagnosticsSelected.filter(
          e => e.idDietaryDiagnostic === diagnostic.id
        )[0].value;
        this.upsert(diagnostic);
      } else {
        if (event.target.checked == true) {
          this.upsert(diagnostic);
        } else {
          this.remove(diagnostic);
        }
      }
    },
    async get() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.data.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = true;

      var result = await AppointmentDietaryDiagnosticService.search(payload);
      if (result.status == 200) {
        if (result.data.result != null) {
          console.log("search", result);
          this.data.dietaryDiagnosticsSelected = result.data.result;
        }
      }

      await this.getDietaryDiagnostics();

      this.closeLoadingDiv(this.defaultDivId);
    },
    async getDietaryDiagnostics() {
      const payload = {
        data: {
          // alwaysShow: true
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await DietaryDiagnosticService.search(payload);

      if (result.status == 200) {
        if (result.data.result != null) {
          this.data.categories = this.getCategories(result.data.result);

          this.data.dietaryDiagnostics = result.data.result;
        }
      }

      this.getCategories(result.data.result);
    },
    async upsert(diagnostic) {
      this.openLoadingInDiv(this.defaultDivId);

      var dataToCreateOrUpdate = {
        idDietaryDiagnostic: diagnostic.id,
        value: diagnostic.value,
        idAppointment: this.data.idAppointment
      };

      const payload = {
        data: dataToCreateOrUpdate,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentDietaryDiagnosticService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    async remove(diagnostic) {
      this.openLoadingInDiv(this.defaultDivId);

      var dataToRemovee = {
        idDietaryDiagnostic: diagnostic.id,
        idAppointment: this.data.idAppointment
      };

      const payload = {
        data: dataToRemovee,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentDietaryDiagnosticService.remove(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    getCategories(dietaryDiagnostics) {
      const listOfCategories = [
        ...new Set(dietaryDiagnostics.map(it => it.idDietaryDiagnosticCategory))
      ];

      var categories = [];

      listOfCategories.forEach(idCategory => {
        let res = dietaryDiagnostics.filter(
          x => x.idDietaryDiagnosticCategory == idCategory
        );

        categories.push(res[1].category);
      });

      return categories;
    },
    openDietaryDiagnosticCreateForm(idDietaryDiagnosticCategory) {
      this.idDietaryDiagnosticCategory = idDietaryDiagnosticCategory;
      this.popupActive = true;
    },
    openDietaryDiagnosticSelect(idDietaryDiagnosticCategory) {
      this.idDietaryDiagnosticCategory = idDietaryDiagnosticCategory;
      this.selectPopUpActive = true;
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}

.vx-card {
  padding-bottom: 10px;
  padding-top: 5px;
  margin-top: 10px;
}
</style>